import { TextLinkKind,TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { ReactActionDialogOptionsForConfirmationDialog } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { ModalInstance } from '~src/commonInfra/dialogs/ReactModalService';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { externalUserTextLinkStyles } from '../styles/ExternalUserConfirmationDialogStyles';
import { EditEphemeralUserFieldProps } from './EditEphemeralUserField';

export function openEditExternalUserConfirmationDialog<ActionParams, TResult>(
    props: EditEphemeralUserFieldProps
  ): ModalInstance<TResult> {

    const actionDialogOptions: ReactActionDialogOptionsForConfirmationDialog<ActionParams, TResult> = {
      title: Messages.groupEphemeralUsers(),
      bodyComponent: EditExternalUserConfirmationDialogBody,
      initialBodyProps: undefined,
      initialDialogState: undefined,
      actionName: Messages.groupEphemeralUserRemoveAccess(),
      action: () => uncheckEphemeralUser(false, props).then(),
      dialogWidth: TabDialogWidth.width500px,
      dismissDialogOnActionFailed: true,
      isActionDelete: true, //set true for ButtonType.Destructive
      centerActionButtons: false
    };

    return openReactActionDialog(actionDialogOptions);
  }

function EditExternalUserConfirmationDialogBody(): JSX.Element {
    return (
      <div data-tb-test-id={'external-user-checkbox-confirmation-dialog'}>
        {<ExternalUserTextLink/>}
        {Messages.groupEphemeralUsersAreYouSure()}
      </div>
    );
  }

export function ExternalUserTextLink(): JSX.Element {
    return <div style={externalUserTextLinkStyles}>
        <span>{Messages.groupEphemeralUsersConfirmationMessage()}</span>
        &nbsp;
        <TextLinkWidget
            testId={'external-user-learn-more'}
            target={'_blank'}
            href={HelpService.getHelpUrlByCategory('groups-ephemeral-users')}
            kind={TextLinkKind.Standalone}>
            {Messages.learnMore()}
        </TextLinkWidget>
        </div>;
}

function uncheckEphemeralUser(checked: boolean, props: EditEphemeralUserFieldProps): Promise<IResult> {
    return new Promise<IResult>((resolve) => {
      props.setExternalUserEnabled(checked);
      resolve({ errors: [] });
    });
}